var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtrgtbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 194,
    viewBox: "0 0 117 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.078 32.7828C225.839 46.5991 237.965 64.8508 244.176 84.6886C245.038 87.437 247.489 89.389 250.374 89.5346L250.547 89.5438C255.59 89.7994 259.179 84.6809 257.157 80.0673C248.867 61.1553 236.054 43.8775 218.883 29.9524C162.211 -16.0062 78.3061 -8.03675 31.5122 47.7756C-3.73831 89.8254 -8.55752 146.955 14.3465 192.946C20.7446 205.792 37.7302 208.95 48.4708 199.433C56.4633 192.351 58.0642 180.599 52.4621 171.505C29.205 133.761 31.3912 83.8451 61.7202 47.9496C98.2778 4.6906 163.291 -2.05168 208.078 32.7828Z",
    fill: "#4E327A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtrgtbg);
export default __webpack_public_path__ + "static/media/btrgtbg.dc8906fbfbc4eb468d1965c5ea804b0e.svg";
export { ForwardRef as ReactComponent };